@let isEditUser = isEditUser$ | async;
@let isB2bPartnerEdit = isB2bPartnerEdit$ | async;

<div class="container-fluid p-4 p-md-8">
    <div class="row">
        <div class="col-12" [ngClass]="{ 'col-xl-9 col-lg-8': isEditUser || isB2bPartnerEdit }">
            <div class="py-6 px-0 border-radius-4 bg-light rounded">
                <div class="mb-5 d-flex flex-column flex-md-row justify-content-between">
                    <h2 class="px-5 my-0">{{ 'global.labels.uploads' | translate }}</h2>
                    <b2b-uploads-filter
                        class="d-block mt-4 mt-md-0"
                        [pending]="pending$ | async"
                        [prgId]="prgId"
                        (submitForm)="handlerFilterUploads($event)" />
                </div>
                @if (b2bProgram.prgType === b2bProgramType.NumberOfTrips) {
                    <b2b-table-number-of-trips-uploads
                        [pending]="pending$ | async"
                        [displayedColumns]="['loadDate', 'fileName', 'operType', 'rideIssued', 'errors', 'logs']"
                        [uploads]="loads$ | async" />
                } @else {
                    <b2b-table-uploads
                        [pending]="pending$ | async"
                        [displayedColumns]="['loadDate', 'fileName', 'operType', 'trfName', 'hasError', 'link']"
                        [uploads]="loads$ | async" />
                }
            </div>
        </div>
        @if (isEditUser || isB2bPartnerEdit) {
            <div class="col-12 col-xl-3 col-lg-4 mt-8 mt-lg-0">
                <div class="p-6 border border-radius-4">
                    <b2b-program-file-upload
                        [loadingFile]="pendingLoadFile$ | async"
                        [b2bPrgType]="b2bProgram.prgType"
                        (uploadFile)="handlerLoadFile($event)" />
                </div>
            </div>
        }
    </div>
</div>
